import React from "react";
import { Cross1Icon } from "@radix-ui/react-icons";
import { Dialog } from "radix-ui";
import "../ui.css";
import { useDisableRadixScrollLock } from "./useDisableRadixScrollLock";
import { useDataUiTheme } from "../utility/getDataUiTheme";
export var RadixModal = function (_a) {
    var open = _a.open, onOpenChange = _a.onOpenChange, title = _a.title, description = _a.description, _b = _a.status, status = _b === void 0 ? "info" : _b, children = _a.children, contentClassName = _a.contentClassName, bodyClassName = _a.bodyClassName;
    var uiTheme = useDataUiTheme();
    useDisableRadixScrollLock(open);
    return (React.createElement(Dialog.Root, { open: open, onOpenChange: onOpenChange, "data-ui-theme": uiTheme },
        React.createElement(Dialog.Portal, null,
            React.createElement(Dialog.Overlay, { className: "radix-modal-overlay" }),
            React.createElement(Dialog.Content, { "aria-describedby": description, className: ["radix-modal-content", contentClassName].filter(Boolean).join(" "), role: "dialog" },
                React.createElement(Dialog.Close, { className: "radix-modal-close-icon", "aria-label": "Close dialog" },
                    React.createElement(Cross1Icon, { "aria-hidden": "true" })),
                React.createElement(Dialog.Title, { className: "radix-modal-title" }, title),
                description ? React.createElement(Dialog.Description, { className: "radix-modal-description" }, description) : null,
                children ? React.createElement("div", { className: ["radix-modal-body", bodyClassName].filter(Boolean).join(" ") }, children) : null,
                React.createElement(Dialog.Close, { className: "radix-modal-close" }, "Close")))));
};
